import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03fd1c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallet" }
const _hoisted_2 = { style: {"line-height":"20px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"6px","font-size":"18px"}
}, null, -1))
const _hoisted_4 = { class: "wallet-balance-num" }
const _hoisted_5 = { class: "price-unit" }
const _hoisted_6 = { class: "wallet-balance-btn" }
const _hoisted_7 = {
  key: 1,
  style: {"line-height":"40px","white-space":"nowrap"}
}
const _hoisted_8 = { style: {"line-height":"20px"} }
const _hoisted_9 = { style: {"font-weight":"700","font-size":"14px","margin-left":"4px"} }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "deliver-num"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/报警灯.png",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_13 = { class: "tips" }
const _hoisted_14 = {
  key: 1,
  class: "deliver-num"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-line" }, null, -1))
const _hoisted_16 = { class: "wallet-bottom" }
const _hoisted_17 = { style: {"display":"flex"} }
const _hoisted_18 = { class: "wallet-bottom-cartAndMsg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/cart.svg" }, null, -1))
const _hoisted_20 = { class: "wallet-bottom-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-bottom-line" }, null, -1))
const _hoisted_22 = { class: "wallet-bottom-cartAndMsg" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/message.svg" }, null, -1))
const _hoisted_24 = { class: "wallet-bottom-title" }
const _hoisted_25 = { style: {"color":"#1C2026"} }

import AppLink from '@/components/common/AppLink.vue'
import { useRtfix, isD2C, isJA } from '@/store'
import { t } from '@/plugins/i18n'
import { computed, onMounted, ref } from 'vue'
import { CustomerShopRespDTO } from '@/apis/interface/customer'
import { useStore } from 'vuex'
import { getUnCheckMoney, getWfTotalPriceApi } from '@/apis/fund'
import { formatPrice } from '@/views/fund/FundList/data'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { getQryDeliveryNum } from '@/apis/inShipping'


export default /*#__PURE__*/_defineComponent({
  props: {
    overviewInfo: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    overviewInfo: CustomerShopRespDTO
}
const store = useStore()
/** 是否为子账号 */
const isSub: boolean = store.getters.isSub
/** 当前店铺id */
const customerShopId = store.getters.curShop

/** 当前店铺信息 */
const shopInfo = computed(() => {
  return store.getters.user.customerShopList.find((item: any) => item.customerShopId === customerShopId)
})
/** 购物车数量 */
const shopcartCount = computed(() => store.state.message.cart)
const noticeCount: any = computed(() => store.state.message.num)

/** 主账号余额 */
const availableAmount = computed(() => props.overviewInfo.availableAmount || 0)
/** 未入账金额-人民币 */
const unCheckCnyAmt = ref(0)
// const unCheckMoneyJPY = ref(0)

/** wf金额待入账金额 */
const wfPrice = ref(0)
// const wfPriceJPY = ref(0)
const deliveryNum = ref(0)

onMounted(async () => {
  /** 获取未入账金额 */
  const res = await getUnCheckMoney({ currencyCode: 'CNY' })
  unCheckCnyAmt.value = res.data.unCheckCnyAmt
  //   unCheckMoneyJPY.value = res.data.unCheckAmt

  /** 获取wf金额待入账金额 */
  const res2 = await getWfTotalPriceApi({
    rechargeType: 1,
    balanceRechargeStatusList: [1, 2, 6],
    customerId: store.getters.user.customerId,
    payChannel: 5,
    // 默认人民币
    rechargeCurrencyCode: 'CNY'
  })
  wfPrice.value = res2.data?.rechargeCnyAmount || 0
  //   wfPriceJPY.value = res2.data?.rechargeAmount || 0

  isSub && getDeliveryNum()
})
/** 包裹因欠费而无法发货，请尽快充值  */
const getDeliveryNum = async () => {
  const res = await getQryDeliveryNum([{
    payStatus: 2,
    customerShopId
  }])
  if (res.data?.length) {
    deliveryNum.value = res.data?.[0].overdueCanotDeliverNum
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppLink, {
      to: _unref(useRtfix)( !_unref(isSub) ? 'CustomerFund' :'StoreFund'),
      class: "wallet-balance-title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
                _unref(taTrack)({
                    event: _unref(TaEvent).BTN_CLICK,
                    value: {
                        position: 'account_balance'
                    }
                })
            ))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(isSub) ? _unref(t)('主账号余额1') : _unref(t)('主账号余额')), 1),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", {
        class: _normalizeClass(Number(__props.overviewInfo?.availableAmount) < 0 ? 'font-red': '')
      }, _toDisplayString(_unref(formatPrice)(_unref(availableAmount))), 3),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('元')), 1)
    ]),
    (!_unref(isSub))
      ? (_openBlock(), _createBlock(AppLink, {
          key: 0,
          to: _unref(useRtfix)('Recharge'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                _unref(taTrack)({
                    event: _unref(TaEvent).BTN_CLICK,
                    value: {
                        position: 'workbench_recharge'
                    }
                })
            ))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('充值')), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (!_unref(isSub))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("未入账金额")), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatPrice)((unCheckCnyAmt.value + wfPrice.value)?.toFixed?.(2)) || 0), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('元')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (Number(deliveryNum.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('有包裹因欠费而无法发货，请尽快转账')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14))
        ])),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(AppLink, {
            to: _unref(useRtfix)('shopcart'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (
                            _unref(taTrack)({
                                event: _unref(TaEvent).BTN_CLICK,
                                value: {
                                    position: 'workbench_shopping_cart'
                                }
                            })
                        ))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("购物车")), 1),
              _createElementVNode("span", {
                class: "wallet-bottom-red",
                style: _normalizeStyle(_unref(shopcartCount) > 0 ? 'color: #EA3B43;': 'color: #505762;')
              }, _toDisplayString(_unref(shopcartCount)), 5)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(AppLink, {
            to: _unref(useRtfix)('Information'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                            _unref(taTrack)({
                                event: _unref(TaEvent).BTN_CLICK,
                                value: {
                                    position: 'workbench_message'
                                }
                            })
                        ))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('消息')), 1),
              _createElementVNode("span", _hoisted_25, [
                _createElementVNode("span", {
                  style: _normalizeStyle([_unref(noticeCount) ? 'color:#EA3B43;': '', {"font-weight":"700"}])
                }, _toDisplayString(_unref(noticeCount)), 5),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('条(未读)')), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}
}

})